import styled from "styled-components";
export const DropdownImg = styled.img `
    width : 50px;
    height: 40px;
`;
export const DropdownAccountNumber = styled.p `
    font-size: 12px;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    padding-left:0.5rem !important;
    letter-spacing: normal;
    color : blue;
    margin: 0;
    padding: 0;
`;
export const DropdownListItem = styled.p `
    font-size: 15px;
    font-weight: 800;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    padding-left:0.5rem !important;
    text-overflow: ellipsis;
    max-width: 172px;
    overflow: hidden;
    white-space: nowrap;
    letter-spacing: normal;    
    margin: 0;
    padding: 0;
`;
export const DropdownDiv = styled.div `
    display: flex;
`;
